interface TickPointLike {
    name?: string;
}

export const formatOvertimeXAxisTick = (
    period: 'day' | 'week' | 'month',
    label: string | number,
    index: number,
    data: TickPointLike[],
): string => {
    const text = String(label);

    if (period === 'month') {
        const [month, year] = text.split(' ');
        if (!month || !year) return text;

        const firstIndexForYear = data.findIndex((point) => {
            const [, y] = String(point.name ?? '').split(' ');
            return y === year;
        });

        return index === firstIndexForYear ? text : month;
    }

    if (period === 'day') {
        const [month, day] = text.split(' ');
        if (!month || !day) return text;

        const firstIndexForMonth = data.findIndex((point) =>
            String(point.name ?? '').startsWith(`${month} `),
        );

        return index === firstIndexForMonth ? text : day;
    }

    return text;
};

export const shouldAngleXAxisTick = (
    period: 'day' | 'week' | 'month',
    dataLength: number,
): boolean => {
    if (period === 'month' && dataLength > 18) {
        return true;
    }
    return false;
};
